import PropTypes from "prop-types";

const WrapType = PropTypes.oneOf(["nowrap", "wrap", "wrap-reverse"]);

const AlignItemsType = PropTypes.oneOf([
	"stretch",
	"center",
	"flex-start",
	"flex-end",
	"baseline"
]);

const AlignContentType = PropTypes.oneOf([
	"stretch",
	"center",
	"flex-start",
	"flex-end",
	"space-between",
	"space-around"
]);

const AlignSelfType = PropTypes.oneOf([
	"auto",
	"stretch",
	"center",
	"flex-start",
	"flex-end",
	"baseline"
]);

const JustifyContentType = PropTypes.oneOf([
	"center",
	"flex-start",
	"flex-end",
	"space-between",
	"space-around"
]);

const JustifyItemsType = PropTypes.oneOf([
	"center",
	"flex-start",
	"flex-end",
	"space-between",
	"space-around"
]);

const JustifySelfType = PropTypes.oneOf([
	"auto",
	"stretch",
	"center",
	"flex-start",
	"flex-end",
	"baseline"
]);

const FlexDirectionType = PropTypes.oneOf([
	"row",
	"row-reverse",
	"column",
	"column-reverse"
]);

export const FlexProps = {
	wrap: PropTypes.oneOfType([
		WrapType,
		PropTypes.shape({
			base: WrapType,
			sm: WrapType,
			md: WrapType,
			lg: WrapType
		})
	]),
	alignItems: PropTypes.oneOfType([
		AlignItemsType,
		PropTypes.shape({
			base: AlignItemsType,
			sm: AlignItemsType,
			md: AlignItemsType,
			lg: AlignItemsType
		})
	]),
	alignContent: PropTypes.oneOfType([
		AlignContentType,
		PropTypes.shape({
			base: AlignContentType,
			sm: AlignContentType,
			md: AlignContentType,
			lg: AlignContentType
		})
	]),
	alignSelf: PropTypes.oneOfType([
		AlignSelfType,
		PropTypes.shape({
			base: AlignSelfType,
			sm: AlignSelfType,
			md: AlignSelfType,
			lg: AlignSelfType
		})
	]),
	justifyContent: PropTypes.oneOfType([
		JustifyContentType,
		PropTypes.shape({
			base: JustifyContentType,
			sm: JustifyContentType,
			md: JustifyContentType,
			lg: JustifyContentType
		})
	]),
	justifyItems: PropTypes.oneOfType([
		JustifyItemsType,
		PropTypes.shape({
			base: JustifyItemsType,
			sm: JustifyItemsType,
			md: JustifyItemsType,
			lg: JustifyItemsType
		})
	]),
	justifySelf: PropTypes.oneOfType([
		JustifySelfType,
		PropTypes.shape({
			base: JustifySelfType,
			sm: JustifySelfType,
			md: JustifySelfType,
			lg: JustifySelfType
		})
	]),
	flexDirection: PropTypes.oneOfType([
		FlexDirectionType,
		PropTypes.shape({
			base: FlexDirectionType,
			sm: FlexDirectionType,
			md: FlexDirectionType,
			lg: FlexDirectionType
		})
	]),
	gap: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			base: PropTypes.string,
			sm: PropTypes.string,
			md: PropTypes.string,
			lg: PropTypes.string
		})
	]),
	children: PropTypes.node
};
